import { useEffect, useState, type JSX } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, type SubscriptionListItem } from '../api.js';
import { useActiveProfileId } from '../active-profile.js';
import { Topbar } from './AdminLayout.js';
import { fmtAmountPlain, fmtDate, relativeTime } from '../utils/format.js';

const STATUS_CHIP: Record<string, string> = {
  pending: 'chip-neutral',
  active: 'chip-ok',
  cancelled: 'chip-neutral',
  completed: 'chip-info',
  failed: 'chip-danger',
};

export function SubscriptionsList(): JSX.Element {
  const nav = useNavigate();
  const [items, setItems] = useState<SubscriptionListItem[] | null>(null);
  const [err, setErr] = useState<string | null>(null);

  const [activeProfileId] = useActiveProfileId();
  useEffect(() => {
    setItems(null);
    api.listSubscriptions().then(setItems).catch((e: Error) => setErr(e.message));
  }, [activeProfileId]);

  return (
    <>
      <Topbar title="Подписки" />
      <div style={{ padding: '24px 28px', flex: 1, overflowY: 'auto' }}>
        {err && (
          <div
            className="card"
            style={{
              padding: 14,
              marginBottom: 14,
              color: 'var(--danger-fg)',
              background: 'var(--danger-subtle-bg)',
            }}
          >
            {err}
          </div>
        )}
        <div className="card">
          <table className="tbl">
            <thead>
              <tr>
                <th>Клиент</th>
                <th>Подписка</th>
                <th>Статус</th>
                <th style={{ textAlign: 'right' }}>Списаний</th>
                <th>Старт</th>
                <th>Создан</th>
              </tr>
            </thead>
            <tbody>
              {items?.map((s) => (
                <tr key={s.id} onClick={() => nav(`/admin/subscriptions/${s.id}`)}>
                  <td>
                    <div style={{ fontWeight: 500 }}><bdi>{s.customerName}</bdi></div>
                    <div style={{ fontSize: 11.5, color: 'var(--fg-subtle)' }}>{s.customerEmail}</div>
                  </td>
                  <td>
                    <div><bdi>{s.plan?.name ?? s.product?.name ?? '—'}</bdi></div>
                    <div style={{ fontSize: 11.5, color: 'var(--fg-subtle)', whiteSpace: 'nowrap' }}>
                      ₪ {fmtAmountPlain(s.plan?.priceIls ?? s.payment?.amount ?? 0)}/мес
                    </div>
                  </td>
                  <td>
                    <span className={'chip no-dot ' + (STATUS_CHIP[s.status] ?? 'chip-neutral')}>
                      {s.status}
                    </span>
                  </td>
                  <td className="num" style={{ textAlign: 'right' }}>
                    {s._count.payments}
                  </td>
                  <td>
                    <span className="subtle" style={{ fontSize: 12 }}>
                      {s.startedAt ? fmtDate(s.startedAt) : '—'}
                    </span>
                  </td>
                  <td>
                    <span className="subtle" style={{ fontSize: 12 }}>
                      {relativeTime(s.createdAt)}
                    </span>
                  </td>
                </tr>
              ))}
              {items && items.length === 0 && (
                <tr className="no-hover">
                  <td colSpan={6} style={{ textAlign: 'center', padding: 32, color: 'var(--fg-subtle)' }}>
                    Подписок пока нет
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
